<template>
  <van-overlay show @click="$emit('close')" class="flex" z-index="1000">
    <div class="text-white m-auto">
      <div class="text-center leading-22 text-medium">
        <div>
          <span>请用微信扫描下方二维码</span>
        </div>
        <div>
          <span>关注微信公众号，随时查询领奖情况</span>
        </div>
        <div class="mt-3">
          <vue-qr text="https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzU2MDc4NTg5MA==&scene=124#wechat_redirect" />
        </div>
      </div>
    </div>
  </van-overlay>
</template>

<script>
import VueQr from 'vue-qr'

export default {
  name: 'OfficialAccount',
  components: { VueQr },
  data() {
    return {
      officialAccountUrl: process.env.VUE_APP_OFFICIAL_ACCOUNT_URL
    }
  }
}
</script>
